"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BinNode = exports.BinChunk = void 0;
const clock_1 = require("../../../json-crdt-patch/clock");
const AbstractRga_1 = require("../rga/AbstractRga");
const json_crdt_patch_1 = require("../../../json-crdt-patch");
const constants_1 = require("../../../json-crdt-patch/constants");
/**
 * @ignore
 * @category CRDT Node
 */
class BinChunk {
    constructor(id, span, buf) {
        this.id = id;
        this.span = span;
        this.len = buf ? span : 0;
        this.del = !buf;
        this.p = undefined;
        this.l = undefined;
        this.r = undefined;
        this.s = undefined;
        this.data = buf;
    }
    merge(data) {
        const length = this.data.length;
        const combined = new Uint8Array(length + data.length);
        combined.set(this.data);
        combined.set(data, length);
        this.data = combined;
        this.span = combined.length;
    }
    split(ticks) {
        if (!this.del) {
            const data = this.data;
            const rightBuffer = data.subarray(ticks);
            const chunk = new BinChunk((0, clock_1.tick)(this.id, ticks), this.span - ticks, rightBuffer);
            this.data = data.subarray(0, ticks);
            this.span = ticks;
            return chunk;
        }
        const chunk = new BinChunk((0, clock_1.tick)(this.id, ticks), this.span - ticks, undefined);
        this.span = ticks;
        return chunk;
    }
    delete() {
        this.del = true;
        this.data = undefined;
    }
    clone() {
        const chunk = new BinChunk(this.id, this.span, this.data);
        return chunk;
    }
    view() {
        return this.data || new Uint8Array(0);
    }
}
exports.BinChunk = BinChunk;
/**
 * Represents the `bin` type in JSON CRDT. The `bin` is a blob of binary data,
 * powered by a Replicated Growable Array (RGA) algorithm.
 *
 * @category CRDT Node
 */
class BinNode extends AbstractRga_1.AbstractRga {
    constructor() {
        // ----------------------------------------------------------------- JsonNode
        super(...arguments);
        /** @ignore */
        this._view = null;
        /** @ignore */
        this.api = undefined;
        /** @ignore */
        this.parent = undefined;
    }
    name() {
        return 'bin';
    }
    view() {
        if (this._view)
            return this._view;
        const res = new Uint8Array(this.length());
        let offset = 0;
        let chunk = this.first();
        while (chunk) {
            if (!chunk.del) {
                const buf = chunk.data;
                res.set(buf, offset);
                offset += buf.length;
            }
            chunk = this.next(chunk);
        }
        return (this._view = res);
    }
    /** @ignore */
    children() { }
    /** @ignore */
    child() {
        return undefined;
    }
    /** @ignore */
    container() {
        return undefined;
    }
    /** @ignore */
    clone() {
        const clone = new BinNode(this.id);
        const count = this.count;
        if (!count)
            return clone;
        let chunk = this.first();
        clone.ingest(count, () => {
            const ret = chunk.clone();
            chunk = this.next(chunk);
            return ret;
        });
        return clone;
    }
    /** @ignore */
    delta(model, cc, ops) {
        const obj = this.id;
        if (!cc.has(obj))
            ops.push(new json_crdt_patch_1.NewBinOp(obj));
        const iterator = this.iterator();
        let lastChunk;
        while (true) {
            const chunk = iterator();
            if (!chunk)
                break;
            const { id, span, del } = chunk;
            const gap = cc.gap((0, clock_1.tick)(id, span - 1));
            if (gap > 0) {
                const data = chunk.data || new Uint8Array(span);
                const offset = Math.max(0, span - gap);
                if (!offset) {
                    const ref = lastChunk ? (0, clock_1.tick)(lastChunk.id, lastChunk.span - 1) : obj;
                    ops.push(new json_crdt_patch_1.InsBinOp(id, obj, ref, data));
                }
                else {
                    const text = data.slice(offset);
                    const ref = (0, clock_1.tick)(id, offset - 1);
                    ops.push(new json_crdt_patch_1.InsBinOp((0, clock_1.tick)(id, offset), obj, ref, text));
                }
            }
            if (del)
                ops.push(new json_crdt_patch_1.DelOp(constants_1.ORIGIN, obj, [(0, clock_1.tss)(id.sid, id.time, span)]));
            lastChunk = chunk;
        }
    }
    // -------------------------------------------------------------- AbstractRga
    /** @ignore */
    createChunk(id, buf) {
        return new BinChunk(id, buf ? buf.length : 0, buf);
    }
    /** @ignore */
    onChange() {
        this._view = null;
    }
    toStringName() {
        return this.name();
    }
}
exports.BinNode = BinNode;
